// @flow
import { Component } from 'react'
import { Router, Route } from 'react-router-dom'
import { hot } from 'react-hot-loader/root'

import { AppendedComponent } from 'view/atoms/appended-component'
import type { ExternalProps } from '../types'
import { MenuContext } from '../context'
import { Header } from './header'
import { Footer } from './footer'
import { Sidebar } from './sidebar'

type Props = {
  // $FlowFixMe[unclear-type]
  history: any,
  options: ExternalProps,
  beforeRender?: () => void,
  afterRender?: () => void,
  onUnmount?: () => void,
}

class ExternalMenu extends Component<Props> {
  componentWillMount() {
    const { beforeRender } = this.props

    if (typeof beforeRender === 'function') {
      beforeRender()
    }
  }

  componentDidMount() {
    const { afterRender } = this.props

    if (typeof afterRender === 'function') {
      afterRender()
    }
  }

  componentWillUnmount() {
    const { onUnmount } = this.props

    if (typeof onUnmount === 'function') {
      onUnmount()
    }
  }

  render() {
    const { history, options = {} } = this.props

    return (
      <Router history={history}>
        <Route
          component={(props) => (
            <MenuContext.Provider value={{ options }}>
              <If condition={options.header}>
                <AppendedComponent domNode={options.headerContainer}>
                  <Header {...props} />
                </AppendedComponent>
                <Sidebar {...props} />
              </If>
              <If condition={options.footer}>
                <AppendedComponent domNode={options.footerContainer}>
                  <Footer {...props} />
                </AppendedComponent>
              </If>
            </MenuContext.Provider>
          )}
        />
      </Router>
    )
  }
}

const HottedExternalMenu = hot(ExternalMenu)

export { HottedExternalMenu as ExternalMenu }
